<template>
    <div id="bloco-dados-area-plantio-certificacao">
        <h2 class="titulo-bloco-dados-area-plantio-certificacao">
            {{ $t('certification.messages.planting_area_data') }}
        </h2>
        <div class="dados-area-plantio-certificacao__linha">
            <div
                class="dados-area-plantio-certificacao__cartao"
                v-if="funcionalidadeAtiva"
            >
                <div class="lyra__cartao">
                    <div class="lyra-cartao-conteudo-interno">
                        <div class="area-plantio-certificacao-card">
                            <div class="area-plantio-certificacao-card__titulo">
                                <span class="area-plantio__titulo">{{
                                    $t('certification.words.total')
                                }}</span>
                            </div>
                            <div
                                class="area-plantio-certificacao-card__informacoes"
                            >
                                <div
                                    class="area-plantio-certificacao-card-soja"
                                >
                                    <i class="lyra-icon lyra-soja"></i>
                                    <span class="area-plantio-span"
                                        >{{
                                            formatters.formatNumberUs(
                                                dadosTotal.areaSoja
                                            )
                                        }}
                                        ha</span
                                    >
                                </div>
                                <div
                                    class="area-plantio-certificacao-card-milho"
                                    v-if="funcionalidadeAtiva"
                                >
                                    <i class="lyra-icon lyra-milho"></i>
                                    <span class="area-plantio-span"
                                        >{{
                                            formatters.formatNumberUs(
                                                dadosTotal.areaMilho
                                            )
                                        }}
                                        ha</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="dados-area-plantio-certificacao__cartao"
                v-for="(dados, index) in dadosCertificacoes"
                :key="index"
            >
                <div class="lyra__cartao">
                    <div class="lyra-cartao-conteudo-interno">
                        <div class="area-plantio-certificacao-card">
                            <div class="area-plantio-certificacao-card__titulo">
                                <span class="area-plantio__titulo"
                                    >{{
                                        `${$t(
                                            'certification.messages.eligible_for'
                                        )} ${dados.tipo || 'N/A'}`
                                    }}
                                </span>
                            </div>
                            <div
                                class="area-plantio-certificacao-card__informacoes"
                            >
                                <div
                                    class="area-plantio-certificacao-card-soja"
                                >
                                    <i class="lyra-icon lyra-soja"></i>
                                    <span class="area-plantio-span"
                                        >{{
                                            formatters.formatNumberUs(
                                                dados.areaSoja
                                            )
                                        }}
                                        ha</span
                                    >
                                </div>
                                <div
                                    class="area-plantio-certificacao-card-milho"
                                    v-if="dados.areaMilho != null"
                                >
                                    <i class="lyra-icon lyra-milho"></i>
                                    <span class="area-plantio-span"
                                        >{{
                                            formatters.formatNumberUs(
                                                dados.areaMilho
                                            )
                                        }}
                                        ha</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatters from '@/utils/formatters';
export default {
    name: 'BlocoDadosAreaPlantio',

    props: {
        dadosAreaPlantio: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formatters,
            dadosTotal: {
                areaSoja: null,
                areaMilho: null
            },
            dadosCertificacoes: [
                {
                    tipo: null,
                    areaSoja: null,
                    areaMilho: null
                }
            ],
            funcionalidadeAtiva: false
        };
    },

    watch: {
        dadosAreaPlantio: function () {
            this.dadosTotal = this.dadosAreaPlantio.itens.filter(item => {
                return item.tipo === 'Total';
            });
            this.dadosCertificacoes = this.dadosAreaPlantio.itens.filter(
                item => {
                    return item.tipo !== 'Total';
                }
            );
        }
    },

    methods: {},

    mounted() {}
};
</script>

<style lang="scss" scoped>
#bloco-dados-area-plantio-certificacao {
    .titulo-bloco-dados-area-plantio-certificacao {
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .dados-area-plantio-certificacao__linha {
        flex-wrap: wrap;
        display: flex;
        margin-bottom: 8px;
        gap: 20px;

        & > .dados-area-plantio-certificacao__cartao {
            flex-grow: 1;
        }

        .dados-area-plantio-certificacao__cartao {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        .lyra__cartao {
            grid-template-columns: 1fr 2fr;
            flex: 1 1 30%;
            align-items: flex-start;
            display: flex;

            flex-direction: column;
            gap: 16px;
            padding: 16px;
            min-height: 82px;

            .lyra-cartao-conteudo-interno {
                display: flex;
                gap: 8px;
                width: 100%;
                justify-content: space-between;

                .area-plantio-certificacao-card {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    justify-content: space-between;
                    min-height: 50px;
                }
            }

            .area-plantio__titulo {
                font-size: 14px;
                font-weight: bold;
            }

            .area-plantio-certificacao-card__informacoes {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                flex-wrap: wrap;
                width: 100%;

                .area-plantio-certificacao-card-soja {
                    .lyra-icon::before {
                        margin-top: 4px;
                        width: 16px !important;
                    }
                }
                .area-plantio-certificacao-card-soja,
                .area-plantio-certificacao-card-milho {
                    display: flex;
                    gap: 4px;
                    align-items: center;

                    .lyra-icon::before {
                        background-color: var(--primary) !important;
                        width: 14px;
                    }
                    .area-plantio-span {
                        font-size: 14px;
                        font-weight: bold;
                        color: var(--primary);
                    }
                }
            }
        }
    }
}
.dados-area-plantio-certificacao__linha:last-child {
    margin-bottom: 0;
}

@media only screen and (max-width: 1334px) {
    .dados-area-plantio-certificacao__cartao {
        min-width: 45% !important;
        -webkit-box-flex: 0;
    }
}
</style>
